import { render, staticRenderFns } from "./AppointmentPatientList.vue?vue&type=template&id=25636da6&"
import script from "./AppointmentPatientList.vue?vue&type=script&lang=js&"
export * from "./AppointmentPatientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25636da6')) {
      api.createRecord('25636da6', component.options)
    } else {
      api.reload('25636da6', component.options)
    }
    module.hot.accept("./AppointmentPatientList.vue?vue&type=template&id=25636da6&", function () {
      api.rerender('25636da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/FamilyProfiles/components/AppointmentPatientList.vue"
export default component.exports